/* LUXEN cart drawer – free-gift sync + refresh after cart changes made by apps. */
(function () {
	'use strict';
	if (window.__luxenCartDrawer) return;
	window.__luxenCartDrawer = true;

	var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
	var busy = false;
	var lastSignature = '';
	var attempts = {};
	var refreshTimer = null;
	var OWN_HEADER = 'X-Luxen-Cart';

	function getCart() {
		return document.getElementById('cart');
	}

	function refreshDrawer() {
		if (window.ajaxCart && typeof window.ajaxCart.refresh === 'function') {
			return window.ajaxCart.refresh().catch(function () {});
		}
		return Promise.resolve();
	}

	function scheduleRefresh(delay) {
		clearTimeout(refreshTimer);
		refreshTimer = setTimeout(refreshDrawer, delay || 350);
	}

	function post(path, payload) {
		var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
		headers[OWN_HEADER] = '1';
		return fetch(root + path, {
			method: 'POST',
			credentials: 'same-origin',
			headers: headers,
			body: JSON.stringify(payload)
		}).then(function (r) { return r.json(); });
	}

	function syncGift() {
		var cart = getCart();
		if (!cart || busy) return;

		var mode = cart.getAttribute('data-lxc-gift-mode') || 'app';
		var variant = parseInt(cart.getAttribute('data-lxc-gift-variant') || '0', 10);
		var eligible = cart.getAttribute('data-lxc-gift-eligible') === 'true';
		var qty = parseInt(cart.getAttribute('data-lxc-gift-qty') || '0', 10);
		var key = cart.getAttribute('data-lxc-gift-key') || '';
		var total = cart.getAttribute('data-lxc-cart-total') || '0';
		if (!variant) return;

		var needsAdd = eligible && qty === 0;
		var needsRemove = !eligible && qty > 0;
		if (!needsAdd && !needsRemove) return;

		// Guard against loops: at most 2 attempts per cart state.
		var signature = [total, qty, eligible ? 1 : 0].join('|');
		attempts[signature] = (attempts[signature] || 0) + 1;
		if (attempts[signature] > 2) return;

		if (mode === 'theme') {
			busy = true;
			var request = needsAdd
				? post('cart/add.js', { items: [{ id: variant, quantity: 1 }] })
				: post('cart/change.js', { id: key, quantity: 0 });
			request
				.catch(function () {})
				.then(function () {
					busy = false;
					return refreshDrawer();
				});
		} else {
			// The free-gift app adds/removes the gift on its own; re-render once it had time to do it.
			scheduleRefresh(1400);
		}
	}

	function onCartRendered() {
		var cart = getCart();
		if (!cart) return;
		var signature = [
			cart.getAttribute('data-lxc-cart-total'),
			cart.getAttribute('data-lxc-item-count'),
			cart.getAttribute('data-lxc-gift-qty')
		].join('|');
		if (signature === lastSignature) return;
		lastSignature = signature;
		syncGift();
	}

	// The theme re-renders the whole drawer after every cart change; keep the
	// scroll position of the content area so the customer stays where they were.
	var lastScrollTop = 0;

	function restoreScroll(cart) {
		var body = cart.querySelector('.lxc-body');
		if (!body || body.__lxcRestored) return;
		body.__lxcRestored = true;
		if (cart.getAttribute('aria-hidden') === 'false' && lastScrollTop > 0) {
			body.scrollTop = lastScrollTop;
		} else {
			lastScrollTop = 0;
		}
	}

	function observe() {
		var cart = getCart();
		if (!cart || cart.__lxcObserved) return;
		cart.__lxcObserved = true;
		cart.addEventListener('scroll', function (e) {
			if (e.target && e.target.classList && e.target.classList.contains('lxc-body')) {
				lastScrollTop = e.target.scrollTop;
			}
		}, true);
		new MutationObserver(function () {
			restoreScroll(cart);
			setTimeout(onCartRendered, 30);
		}).observe(cart, { childList: true });
		restoreScroll(cart);
		onCartRendered();
	}

	// Review carousel arrows (CSS scroll-snap does the rest).
	document.addEventListener('click', function (e) {
		var btn = e.target.closest ? e.target.closest('.lxc-rev-nav') : null;
		if (!btn) return;
		var wrap = btn.closest('.lxc-reviews');
		var list = wrap && wrap.querySelector('.lxc-rev-list');
		if (!list) return;
		e.preventDefault();
		var card = list.querySelector('.lxc-rev');
		var step = card ? card.getBoundingClientRect().width + 10 : list.clientWidth * 0.8;
		list.scrollBy({ left: step * parseInt(btn.getAttribute('data-dir') || '1', 10), behavior: 'smooth' });
	});

	// Cart changes made by other scripts (apps) don't re-render the drawer – catch them.
	var cartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
	function isForeignMutation(url, body, headers) {
		if (!url || !cartMutation.test(String(url))) return false;
		if (headers && (headers[OWN_HEADER] || (typeof headers.get === 'function' && headers.get(OWN_HEADER)))) return false;
		var text = '';
		if (typeof body === 'string') text = body;
		else if (body && typeof FormData !== 'undefined' && body instanceof FormData) text = body.has('sections') ? 'sections' : (body.has('note') ? 'note' : '');
		else if (body && typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) text = body.toString();
		// Theme requests ask for re-rendered sections; note saves must not re-render while typing.
		if (/sections/.test(text) || /"note"|(^|&)note=/.test(text)) return false;
		return true;
	}

	if (window.fetch) {
		var nativeFetch = window.fetch;
		// The theme changes quantities by line position ("line": 3). If the cart order
		// changes in between (e.g. the free-gift app adds/moves the gift, or several
		// quick +/- clicks), that position is stale and Shopify answers "line parameter
		// is invalid" – or updates the wrong product. Send the stable line key instead.
		var lineChange = /\/cart\/change(\.js)?(\?|$)/;
		function useLineKey(url, init) {
			if (!init || typeof init.body !== 'string' || !lineChange.test(String(url))) return init;
			var data;
			try { data = JSON.parse(init.body); } catch (e) { return init; }
			if (!data || data.id || data.line === undefined || data.line === null) return init;
			var el = document.querySelector('#cart [data-line="' + parseInt(data.line, 10) + '"][data-line-key]') ||
				document.querySelector('[data-line="' + parseInt(data.line, 10) + '"][data-line-key]');
			var key = el && el.getAttribute('data-line-key');
			if (!key) return init;
			delete data.line;
			data.id = key;
			var copy = {};
			for (var k in init) copy[k] = init[k];
			copy.body = JSON.stringify(data);
			return copy;
		}

		function requestUrl(input) {
			if (!input) return '';
			if (typeof input === 'string') return input;
			if (typeof Request !== 'undefined' && input instanceof Request) return input.url;
			return String(input); // URL objects
		}

		window.fetch = function (input, init) {
			var foreign = false;
			var fixedInit = init;
			// Detection must never break the real request: on any error, fall back to the native call.
			try {
				var url = requestUrl(input);
				if (cartMutation.test(url)) {
					var isRequest = typeof Request !== 'undefined' && input instanceof Request;
					var headers = (init && init.headers) || (isRequest ? input.headers : null);
					// A Request object's body can't be inspected without consuming it, so only the headers count.
					foreign = isRequest && !(init && init.body) ? !(headers && headers.get && headers.get(OWN_HEADER)) : isForeignMutation(url, init && init.body, headers);
					fixedInit = useLineKey(url, init);
				}
			} catch (err) {
				foreign = false;
				fixedInit = init;
			}
			var p = fixedInit !== init ? nativeFetch.call(this, input, fixedInit) : nativeFetch.apply(this, arguments);
			if (foreign) {
				p.then(function (r) { if (r && r.ok) scheduleRefresh(); }).catch(function () {});
			}
			return p;
		};
	}
	if (window.XMLHttpRequest) {
		var open = XMLHttpRequest.prototype.open;
		var send = XMLHttpRequest.prototype.send;
		XMLHttpRequest.prototype.open = function (method, url) {
			this.__lxcUrl = url;
			return open.apply(this, arguments);
		};
		XMLHttpRequest.prototype.send = function (body) {
			try {
				if (isForeignMutation(this.__lxcUrl, body)) {
					var xhr = this;
					this.addEventListener('loadend', function () {
						if (xhr.status >= 200 && xhr.status < 300) scheduleRefresh();
					});
				}
			} catch (err) {}
			return send.apply(this, arguments);
		};
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', observe);
	} else {
		observe();
	}
	document.addEventListener('shopify:section:load', function () {
		lastSignature = '';
		observe();
	});
})();
